import React, { useEffect, useState } from 'react';
import { TwitterTweetEmbed } from 'react-twitter-embed';
import InstagramEmbed from 'react-instagram-embed';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import useIsMobile from '../../hooks/useIsMobile';

import TextPlugin from '../cms/TextPlugin';

import './SocialEmbed.module.css';

const SocialEmbedSection = ({
  body,
  embeds,
  social_embed_section_id,
  children,
  classes
}) => {
  const wideScreen = useIsMobile(1115);
  const middleScreen = useIsMobile(840);
  const [firstCol, setFirstCol] = useState([]);
  const [secondCol, setSecondCol] = useState([]);
  const [thirdCol, setThirdCol] = useState([]);
  const [safari, setSafari] = useState(false);

  useEffect(
    () => {
      let rowNum = !wideScreen ? 3 : !middleScreen ? 2 : 1;
      setFirstCol(firstCol.filter(e => false));
      setSecondCol(secondCol.filter(e => false));
      setThirdCol(thirdCol.filter(e => false));
      let i = 0;
      embeds.map(embed => {
        i % rowNum === 0
          ? setFirstCol(firstCol => firstCol.concat(embed))
          : i % rowNum === 1
          ? setSecondCol(secondCol => secondCol.concat(embed))
          : setThirdCol(thirdCol => thirdCol.concat(embed));
        i++;
      });
    },
    [wideScreen, middleScreen]
  );

  useEffect(() => {
    if (navigator) {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('safari') !== -1 && !(ua.indexOf('chrome') > -1)) {
        setSafari(true);
      }
    }
  }, []);

  const createEmbed = embed => (
    <div key={embed.id}>
      {embed.platform === 'twitter' && (
        <TwitterTweetEmbed
          tweetId={embed.postid}
          options={{
            cards: 'hidden',
            width: `${safari ? 320 : 400}`
          }}
        />
      )}
      {embed.platform === 'instagram' && (
        <InstagramEmbed
          url={`https://www.instagram.com/p/${embed.postid}`}
          maxWidth={safari ? 320 : 400}
          hideCaption={true}
          containerTagName="div"
          protocol=""
          injectScript
          onLoading={() => {}}
          onSuccess={() => {}}
          onAfterRender={() => {}}
          onFailure={() => {}}
        />
      )}
    </div>
  );

  const mediaembed = (
    <Cell largeSize={24}>
      <div styleName="embeds">
        <div styleName="firstCol">
          {firstCol.map(embed => {
            return createEmbed(embed);
          })}
        </div>
        {!middleScreen && (
          <div styleName="secondCol">
            {secondCol.map(embed => {
              return createEmbed(embed);
            })}
          </div>
        )}
        {!wideScreen && (
          <div styleName="thirdCol">
            {thirdCol.map(embed => {
              return createEmbed(embed);
            })}
          </div>
        )}
      </div>
    </Cell>
  );
  const mediaembed_safari = (
    <Cell largeSize={24}>
      <div styleName="embeds_safari">
        {embeds.map(embed => {
          return createEmbed(embed);
        })}
      </div>
    </Cell>
  );

  return (
    <div
      id={social_embed_section_id}
      className={classes}
      style={{ marginTop: '6rem' }}
    >
      <div>
        <Grid direction="x" primaryAlignment="align-center">
          <Cell largeSize={16}>
            <div className="mobile-padding" style={{ textAlign: 'center' }}>
              <TextPlugin body={body}>{children}</TextPlugin>
            </div>
          </Cell>
        </Grid>
        <Grid
          direction="x"
          primaryAlignment="align-center"
          styles={{ marginTop: '20px' }}
        >
          {safari ? mediaembed_safari : mediaembed}
        </Grid>
      </div>
    </div>
  );
};

export default DisplayComponent(SocialEmbedSection);
